"use strict";

import { ButtonSize } from "../Button/Button";
import { TextInputSize } from "../TextInput/TextInput";
export var getButtonSize = function getButtonSize() {
  var fieldSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "medium";
  switch (fieldSize) {
    case "small":
      {
        return ButtonSize.Small;
      }
    case "medium":
      {
        return ButtonSize.Medium;
      }
    case "large":
      {
        return ButtonSize.Large;
      }
    default:
      {
        return ButtonSize.Medium;
      }
  }
};
export var getTextInputSize = function getTextInputSize() {
  var fieldSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "medium";
  switch (fieldSize) {
    case "small":
      {
        return TextInputSize.Small;
      }
    case "medium":
      {
        return TextInputSize.Medium;
      }
    case "large":
      {
        return TextInputSize.Large;
      }
  }
};
export var getSegmentedControlSize = function getSegmentedControlSize() {
  var fieldSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "medium";
  switch (fieldSize) {
    case "small":
      {
        return "s";
      }
    case "medium":
      {
        return "m";
      }
    case "large":
      {
        return "l";
      }
  }
};
export var getSelectSize = function getSelectSize() {
  var fieldSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "medium";
  switch (fieldSize) {
    case "small":
      {
        return "s";
      }
    case "medium":
      {
        return "m";
      }
    case "large":
      {
        return "l";
      }
  }
};
export var getCheckboxSize = function getCheckboxSize() {
  var fieldSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "medium";
  switch (fieldSize) {
    case "small":
      {
        return "s";
      }
    case "medium":
      {
        return "m";
      }
    case "large":
      {
        return "l";
      }
  }
};